import { DefaultState } from 'store/reducers/types';

export const READ_WORKED_IN_LAST_30_DAYS_DATA_REQUEST = 'READ_WORKED_IN_LAST_30_DAYS_DATA_REQUEST';
export const READ_WORKED_IN_LAST_30_DAYS_DATA_SUCCESS = 'READ_WORKED_IN_LAST_30_DAYS_DATA_SUCCESS';
export const READ_WORKED_IN_LAST_30_DAYS_DATA_FAILURE = 'READ_WORKED_IN_LAST_30_DAYS_DATA_FAILURE';

export type WorkedInLast30DaysData = {
  rows: Array<{
    fullName: string;
    futureSlots: number;
    id: number;
    inThreeWeeksSlots: number;
    inTwoWeeksSlots: number;
    lastCallLog: string | null;
    lastDaysSlots: number;
    metro: string;
    nextWeekSlots: number;
    thisWeekSlots: number;
  }>;
  totalCount: number;
};

export type WorkedInLast30DaysState = DefaultState & {
  contents?: WorkedInLast30DaysData;
};

interface ReadWorkedInLast30DaysDataRequest {
  type: typeof READ_WORKED_IN_LAST_30_DAYS_DATA_REQUEST;
};

interface ReadWorkedInLast30DaysDataSuccess {
  type: typeof READ_WORKED_IN_LAST_30_DAYS_DATA_SUCCESS,
  contents: WorkedInLast30DaysData;
}

interface ReadWorkedInLast30DaysDataFailure {
  type: typeof READ_WORKED_IN_LAST_30_DAYS_DATA_FAILURE;
}

export type WorkedInLast30DaysActionTypes = ReadWorkedInLast30DaysDataRequest | ReadWorkedInLast30DaysDataSuccess | ReadWorkedInLast30DaysDataFailure;